export default "__VITE_ASSET__BwIQiIP1__"